"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var api_fetching_component_1 = require("./api-fetching.component");
var entity_resolver_1 = require("../_resolvers/entity.resolver");
var schema_pk_resolver_1 = require("./schema-pk.resolver");
var routes = [
    {
        path: '',
        component: api_fetching_component_1.ApiFetchingComponent,
        resolve: {
            rsEntity: entity_resolver_1.EntityResolver,
            rsSchemaPkList: schema_pk_resolver_1.SchemaPkResolver,
        }
    }
];
var ApiFetchingModule = /** @class */ (function () {
    function ApiFetchingModule() {
    }
    return ApiFetchingModule;
}());
exports.ApiFetchingModule = ApiFetchingModule;
